module.exports = __webpack_public_path__ + "img/pure-fruit-cake.5bc2ebc2.jpg";